import Vue from "vue";
import { uNumber } from "@/lib";

export const MUTATIONS = {
  MODIFY_CARD_DATA: "MODIFY_CARD_DATA",
  CANCEL_CARD_DATA_CHANGES: "CANCEL_CARD_DATA_CHANGES",
  CLEAR_CARD_DATA: "CLEAR_CARD_DATA",
  COMPARED_CARDS_ADD: "COMPARED_CARDS_ADD",
  COMPARED_CARDS_TOGGLE: "COMPARED_CARDS_TOGGLE",
  COMPARED_CARDS_DELETE: "COMPARED_CARDS_DELETE",
  COMPARED_CARDS_CLEAR: "COMPARED_CARD_CLEAR",

  NOTIFICATION_PUSH: "NOTIFICATION_PUSH",
  NOTIFICATION_CLEAR: "NOTIFICATION_CLEAR",
  NOTIFICATION_CLEAR_ALL: "NOTIFICATION_CLEAR_ALL",
};

// приватные мутации
export const P_MUTATIONS = {
  SET_LOADING: "P__SET_LOADING",
  SET_SAVING: "P__SET_SAVING",
  SET_FILE_LOADING: "P__SET_FILE_LOADING",
  SET_FILE_SAVING: "P__SET_FILE_SAVING",
  SET_DICTIONARY: "P__SET_DICTIONARY",
  SET_CARD_DATA: "P__SET_CARD_DATA",
  SET_CARD_FILE: "P__SET_CARD_FILE",
  DETACH_CARD_FILE: "P__DETACH_CARD_FILE",
  SET_CARDS: "P__SET_CARDS",
  UPDATE_CARD_IN_CARDS: "P__UPDATE_CARD_IN_CARDS",
  SET_COMPARED_CARD_DATA: "P__SET_COMPARED_CARD_DATA",
  SET_USER: "P__SET_USER",
};

export const mutations = {
  [P_MUTATIONS.SET_FILE_LOADING]: (state, payload) =>
    (state.isFileLoading = payload),
  [P_MUTATIONS.SET_FILE_SAVING]: (state, payload) =>
    (state.isFileSaving = payload),

  [P_MUTATIONS.SET_LOADING]: (state, payload) => (state.isLoading = payload),
  [P_MUTATIONS.SET_SAVING]: (state, payload) => (state.isSaving = payload),

  [P_MUTATIONS.SET_DICTIONARY]: (state, payload) =>
    (state.dictionary = payload),
  [P_MUTATIONS.SET_CARDS]: (state, payload) => {
    state.cards = payload;
  },
  [P_MUTATIONS.UPDATE_CARD_IN_CARDS]: (state, payload) => {
    const index = state.cards.findIndex((item) => item.id === payload.id);
    if (index === -1) {
      state.cards.push(payload);
    } else {
      state.cards.splice(index, 1, payload);
    }
  },
  [MUTATIONS.MODIFY_CARD_DATA]: (state, modification) => {
    const changes = state.changes;
    state.changes = Object.assign({}, changes, modification);
  },
  [MUTATIONS.CANCEL_CARD_DATA_CHANGES]: (state) => (state.changes = {}),

  [P_MUTATIONS.SET_CARD_DATA]: (state, payload) => {
    state.card = payload;
    state.changes = {};
  },

  [MUTATIONS.CLEAR_CARD_DATA]: (state) => {
    state.card = { uNumber: uNumber() };
    state.changes = {};
  },

  [P_MUTATIONS.SET_CARD_FILE]: (state, payload) => {
    const { fieldName, update } = payload;
    state.changes[fieldName].shift();
    if (!state.changes[fieldName].length) {
      Vue.delete(state.changes, fieldName);
    }
    if (!state.card[fieldName]) {
      state.card[fieldName] = [];
    }
    state.card[fieldName].push(update);
  },

  [P_MUTATIONS.DETACH_CARD_FILE]: (state, payload) => {
    const { fieldName, uuid } = payload;
    if (state.card[fieldName]) {
      const idx = state.card[fieldName].findIndex((item) => item.uuid === uuid);
      if (idx !== -1) state.card[fieldName].splice(idx, 1);
    }
  },

  [P_MUTATIONS.SET_USER]: (state, payload) => (state.user = payload),

  [MUTATIONS.COMPARED_CARDS_ADD]: (state, payload) => {
    if (!state.compared.includes(payload)) {
      state.compared.push(payload);
    }
  },
  [MUTATIONS.COMPARED_CARDS_TOGGLE]: (state, payload) => {
    const index = state.compared.findIndex((item) => item === payload);
    if (index === -1) {
      state.compared.push(payload);
    } else {
      state.compared.splice(index, 1);
    }
  },
  [MUTATIONS.COMPARED_CARDS_DELETE]: (state, payload) => {
    const index = state.compared.findIndex((item) => item === payload);
    if (index !== -1) {
      state.compared.splice(1, index);
    }
  },
  [MUTATIONS.COMPARED_CARDS_CLEAR]: (state) => {
    state.compared = [];
    state.comparedData = [];
  },

  [P_MUTATIONS.SET_COMPARED_CARD_DATA]: (state, payload) =>
    (state.comparedData = payload),

  [MUTATIONS.NOTIFICATION_PUSH]: (state, payload) =>
    state.notifications.push(payload),

  [MUTATIONS.NOTIFICATION_CLEAR]: (state, payload) =>
    state.notifications.splice(payload, 1),

  [MUTATIONS.NOTIFICATION_CLEAR_ALL]: (state) => (state.notifications = []),
};
